import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import ECNs from '../ECNs';
import volvoLogo from '../../images/volvo-logo.jpeg'
import SideFilters from '../SideFilter';
import "./style.css";
import LivoPhantomPrime from '../components/LivoPhantomPrime';
import { Spin, Form, Select, Card } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from '../../components/Liracrypt/liracrypt';
const LineWorkInstructions = ({
    urlData,
    pageName,
    setPageHeader,
    urlEndpoint
}) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [loadLineAccess, setLoadLineAccess] = useState();
    const [settings, setSettings] = useState();
    const [settingValues, setSettingValues] = useState();
    const [selectedLid, setSelectedLid] = useState();
    const [pageTitle, setPageTitle] = useState("");

    useEffect(() => {
        liracrypt.get("/linedashboard/access", {})
            .then(response => {
                
                setLoadLineAccess(response.data.data);
            }).catch(err => {
                console.log(err);
            })
    }, []);

    const selectLineOption = (
        <div
            className="dash"
            style={{
                background: "#05246a",
                height: "100vh",
                backgroundColor: "#262626",
                overflow: "hidden",
            }}
        >
            <Card
                title={
                    <span style={{ fontWeight: 600 }}>Please select a line</span>
                }
                bordered={false}
                style={{
                    width: "600px",
                    margin: "10% auto",
                    backgroundColor: "#424358",
                    border: 0,
                    boxShadow: "5px 5px 10px #1f1f1f, -5px -5px 10px #2d2d2d",
                    borderRadius: "10px",
                    fontWeight: "600",
                    padding: "10px",
                }}
            >
                {loadLineAccess ? (
                    <Form.Item
                        className="selectLine"
                        rules={[{ required: true, message: "Select a line" }]}
                    >
                        <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select a line"
                            optionFilterProp="children"
                            onChange={(value) => {
                                
                                setSelectedLid(value);
                            }}
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {loadLineAccess.map((obj) => (
                                <Select.Option value={obj._id}>{obj.lame}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : (
                    <div className="Loading">
                        <Spin indicator={antIcon} />
                    </div>
                )}
            </Card>
        </div>
    )


    return (
        <div className="line-work-instruction">
            {
                selectedLid ?
                    <>
                        <Header
                            className={"livo-header"}
                            settings={{
                                ld_PageTitle: pageTitle,
                                ld_Logo_Comp: {
                                    text: volvoLogo
                                },
                                ld_Logo_Prod: {
                                    text: "http://www.liradolf.com/wp-content/uploads/2015/01/Logo/DigitalFactory.png"
                                }
                            }}
                            settingValues={{
                                settingValues,
                                ld_PageTitle: pageTitle,
                            }}
                        />
                        {/* <SideFilters layoutPosition="start" colSpan={24} urlData={urlData} urlEndpoint={urlEndpoint} />
            <p>I am LineWorkInstructions</p> */}
                        <LivoPhantomPrime
                            setPageTitle={setPageTitle}
                            colSpan={24}
                            layoutPosition="start"
                            filterType="sideBar"
                            button="Search"
                            urlEndpoint={urlEndpoint}
                            urlData={{
                                lid: selectedLid
                            }}
                        />
                        <ECNs selectedLid={selectedLid} />
                    </> :
                    selectLineOption
            }
        </div>
    )
};

export default LineWorkInstructions;